//store/modules/companyProfile.module.js
import CompanyProfileService from "@/services/companyProfile.service";

const state = {
  companyProfile: null,
};

const mutations = {
  SET_COMPANY_PROFILE(state, profile) {
    state.companyProfile = profile;
  },
  CLEAR_COMPANY_PROFILE(state) {
    state.companyProfile = null;
  },
};

const actions = {
  // load the current user’s profile
  async fetchCompany({ commit }, id) {
    const res = await CompanyProfileService.index();
    const profile = res.data.data[0] || null;
    commit("SET_COMPANY_PROFILE", profile);
    return profile;
  },

  // create or update
  async saveCompany({ commit }, payload) {
    let res;

    // detect FormData vs plain object
    const isFormData = typeof payload.get === "function";
    const hasId = isFormData ? !!payload.get("id") : !!payload.id;

    if (hasId) {
      // update
      res = await CompanyProfileService.update(payload);
    } else {
      // create
      res = await CompanyProfileService.store(payload);
    }

    // commit whatever came back
    commit("SET_COMPANY_PROFILE", res.data.data);
    return res.data.data;
  },

  
};

const getters = {
  companyProfile: (state) => state.companyProfile,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
